import { Button, Modal, Form, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';

import { AppContext } from './context/AppContext';
import { jwtDecode } from "jwt-decode";
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';




const LoginPage = () => {

    const [validated, setValidated] = useState(false);
    const modalFormLogin = useRef(null);
    const[Error, setError] = useState(null); 
    const [showLogin, setShowLogin] = useState(false);
    const [inProgress, setInProgress] = useState(false);
    const navigate = useNavigate();

    const { setToken, setUser, currentUser, setLoadingApp } = useContext(AppContext);

    const handleCloseLogin = () => setShowLogin(false);

    const buttonClicked = () => setInProgress(true);
      
    
    const handleSubmitLogin = (event) => {        

        const form = event.currentTarget;
        if (form.checkValidity() === false) {
          event.preventDefault();
          event.stopPropagation();
          setValidated(true);
          return;
        }
      
      
        setValidated(false);
        setInProgress(true);
        setError(null);
              
        event.preventDefault();
      
        let sPasscode = modalFormLogin.current.querySelector('#passcode').value;
        const frmFormData = new FormData();
      
          frmFormData.append("password", sPasscode)             
          const sURL = process.env.REACT_APP_API_BASE_URL + 'Token';
      
          
          const headers = {
            'Content-Type': 'application/json',        
          };
      
          axios.post(sURL,frmFormData,{headers})      
          .then((Response)=>{
      
            console.log(Response)
            let sUserData = Response.data;
            
            localStorage.clear();
            localStorage.setItem(process.env.REACT_APP_API_AUTH_TOKEN,Response.data);  
      
            const token = Response.data;
            const decoded = jwtDecode(token);
      
            setToken(token);
            setUser(decoded);    

            localStorage.setItem("UserAuth",decoded.accesstype);  
            setInProgress(false);

            navigate("/");
      
          }).catch(error => {              
       
              setError(error);   
              setInProgress(false);  
              
              

          });      
      
      }

console.log(Error)


  return (
    <>
    <Modal show={true} onHide={handleCloseLogin} backdrop="static" aria-labelledby="contained-modal-title-vcenter" centered> 
    <Form ref={modalFormLogin} noValidate validated={validated} onSubmit={handleSubmitLogin}>
    <Modal.Header closeButton>
      <Modal.Title>Organization Code</Modal.Title>
    </Modal.Header>   
    <Modal.Body>        
            <Form.Group className="mb-3" >
                <Form.Label>Please Enter Organization Passcode</Form.Label>
                <Form.Control type="text" placeholder="" required id="passcode" />
                <Form.Control.Feedback type="invalid">
                    Please enter your passcode.
                </Form.Control.Feedback>
                {Error && Error.message.indexOf("status code 400") && <><span style={{color:"red",}}>Invalid Organization PassCode</span></>}
            </Form.Group>                
    </Modal.Body>
    
    <Modal.Footer>

    

      {!inProgress && 
      <>
      <Button variant="secondary" onClick={handleCloseLogin}>
        Close
      </Button>
      <Button variant="success" type='submit' >
        Login
      </Button>     
      </>
      }
      {inProgress && <span><h6><Spinner animation="grow" /> Please Wait...</h6></span> }
      
      
      

    </Modal.Footer> 
</Form>
</Modal>
</>
  )
}

export default LoginPage